{
  "tab": "Sponsor",
  "page": {
    "title": "Sponsors",
    "subtitle": "Season {season} deal and what it pays.",
    "subtitleNoSeason": "Your deal and what it pays.",
    "chooseCta": "Choose next season's sponsor",
    "seasonMeta": "Season {season} · division {division}",
    "seasonMetaNoDivision": "Season {season}",
    "dealLine": "{variant} · signed for season {season}",
    "goToNextSeason": "Go to Next season",
    "howMoneyWorks": "How sponsor money works",
    "perStageLine": "Per stage {rate} CZ$, {count, plural, one {# stage left is} other {# stages left are}} worth {worth} CZ$",
    "nextSeasonOpen": "Next season: {count, plural, one {# offer is} other {# offers are}} open, the amount locks when you sign",
    "nextSeasonClosed": "Next season: offers open when season {season} ends",
    "errorTitle": "Couldn't load your sponsors",
    "error": "Nothing was lost and your deal is safe. Try again.",
    "retry": "Try again",
    "tab": {
      "overview": "Overview",
      "deal": "Deal",
      "payments": "Payments",
      "next": "Next season"
    },
    "stat": {
      "paidSoFar": "Paid so far",
      "guaranteed": "Guaranteed",
      "earnedOnTop": "Earned on top",
      "stagesRidden": "Stages ridden",
      "stagesOf": "{ridden} of {total}"
    },
    "noContract": {
      "title": "Sign your first sponsor deal",
      "description": "Offers open on the Next season tab as soon as your club can negotiate.",
      "action": "Go to Next season"
    },
    "deal": {
      "paidDayOne": "Paid on day one",
      "stagesInDivision": "{count} stages in division {division}",
      "overTheSeason": "{amount} CZ$ over the season",
      "divisionAdjustment": "Division adjustment",
      "divisionAdjustmentSub": "Deal priced for division {signed}, you race in division {current}",
      "everySeason": "Every season",
      "signingBonus": "Signing bonus",
      "signingBonusSub": "Paid when you sign",
      "stageWinBonus": "Stage win bonus",
      "stageWinBonusSub": "Per stage win",
      "podiumBonus": "Podium bonus",
      "podiumBonusSub": "Per podium, 2nd to 3rd",
      "capPerSeason": "Cap {amount} CZ$ per season",
      "seasonObjective": "Season objective bonus",
      "seasonObjectiveTop40": "Finish top 40% of your division",
      "seasonObjectiveTopHalf": "Finish top half of your division",
      "runsThrough": "Runs through season {season}"
    },
    "payments": {
      "title": "Paid so far this season",
      "source": "Source",
      "stages": "Stages",
      "amount": "Amount",
      "total": "Total",
      "group": {
        "guaranteed": "Guaranteed",
        "stagesAt": "Stages at {rate} CZ$",
        "stages": "Stages",
        "bonuses": "Bonuses"
      },
      "row": {
        "seasonBase": "Season base",
        "seasonBaseSub": "Contract guarantee",
        "divisionAdjustment": "Division adjustment",
        "divisionAdjustmentSub": "Deal priced for division {division}",
        "stageWin": "Stage win",
        "podium": "Podium",
        "resultBonus": "Result bonus"
      },
      "empty": {
        "title": "Watch your first payment land",
        "description": "Sponsor money shows up here once your season base is credited and your team starts racing.",
        "action": "See the deal"
      }
    },
    "next": {
      "title": "Next season",
      "meta": "{count, plural, one {# offer} other {# offers}} · division {division} · {stages} stages",
      "metaEstimated": "{count, plural, one {# offer} other {# offers}} · division {division} · {stages} stages (estimate)",
      "metaClosed": "Offers open when season {season} ends",
      "dealType": "{variant} · {count, plural, one {# season} other {# seasons}}",
      "ifEveryStage": "{amount} CZ$ if you ride every stage",
      "noBonuses": "None",
      "pricingTitle": "How the offers are priced",
      "column": {
        "sponsor": "Sponsor",
        "guaranteed": "Guaranteed",
        "perStage": "Per stage",
        "bonuses": "Bonuses on top"
      },
      "empty": {
        "title": "Offers open when season {season} ends",
        "description": "All five offers open the day your current deal ends.",
        "action": "Read the sponsor rules"
      }
    }
  },
  "cta": {
    "title": "Choose your sponsor for season {season}",
    "body": "Five sponsors are at the table, each with its own way of paying you. Compare the deals and lock in your backing.",
    "button": "View offers",
    "pendingTitle": "Sponsor selected for season {season}",
    "pendingBody": "You have signed a deal for the upcoming season. You can still switch to a different offer until the season starts.",
    "changeButton": "Change choice"
  },
  "offers": {
    "title": "Choose your sponsor",
    "subtitle": "Five sponsors, five ways to earn in season {season}.",
    "unitDefinition": "Your sponsor pays for each stage your team starts. Training days do not earn this payment.",
    "unitCount": "Division {division} rides {count} stages in season {season}, and every one of them pays.",
    "unitPerDay": "They are spread over {days} calendar days, so most days carry about {perDay} stages.",
    "divisionNote": "The deal itself pays the same maximum whichever division you pick above. Division only changes how many stages you earn it over, and that sets the rate per stage. The division adjustment is a separate line and is shown above when it applies.",
    "divisionPicker": "Preview rate for a division",
    "divisionPill": "Division {division} · {count} stages",
    "deadline": "The amount locks the moment you sign, priced from the division and the results you have that day, and it stays locked for the whole contract. The deal itself starts with season {season}. If you don't choose, the club signs the 1-season safe deal for you at the price these offers opened at.",
    "amountFollowsClub": "The amount follows your own club: your reputation, your division and where you stand in your group. Two clubs can pick the same sponsor and get different offers.",
    "empty": "No offers are available right now. A new deal can be negotiated once the current contract is up for renewal.",
    "choose": "Choose",
    "pending": "Selected",
    "reviewSign": "Review & sign",
    "confirmBody": "Sign with {sponsor} for {count, plural, one {# season} other {# seasons}}? You can change your pick until season {season} starts.",
    "signDeal": "Sign deal",
    "cancel": "Cancel",
    "acceptFailed": "The deal was not signed. Nothing changed. Try again.",
    "guaranteedShare": "{pct}% of the deal is guaranteed",
    "boardNote": "Board satisfaction adjusts the guaranteed part by up to ±20%. It does not touch per-stage money or bonuses: those are paid in full, on top, as you earn them.",
    "divisionAdjustmentUp": "If you race in Division {division} on this deal, a division adjustment of {amount} CZ$ is paid on top every season, because the deal is priced for Division {signed}.",
    "divisionAdjustmentDown": "If you race in Division {division} on this deal, {amount} CZ$ is deducted every season, because the deal is priced for Division {signed}.",
    "calendarEstimate": "I use your current calendar to estimate the rate for the first season of the deal until next season's calendar is ready. The rate is recalculated when the deal starts and stays fixed for the remaining seasons of a multi-season deal.",
    "calendarUnknown": "Next season's calendar is not ready, so I cannot show a reliable rate per stage yet. The season total is shown below.",
    "unitCountEstimate": "This estimate uses the {count} stages in your current division {division}.",
    "rateUnknown": "Awaiting calendar"
  },
  "variant": {
    "safe": "The safe deal",
    "loyal": "The loyal deal",
    "racing": "The racing deal",
    "results": "The results deal",
    "ambition": "The ambition deal",
    "predictable": "Steady backer",
    "activity": "Race-day backer",
    "long": "Long-term partner"
  },
  "clause": {
    "signing": "{amount} CZ$ signing bonus, paid up front",
    "stageWin": "{amount} CZ$ per stage win",
    "podium": "{amount} CZ$ per podium (2nd–3rd)",
    "podiumCapped": "{amount} CZ$ per podium (2nd–3rd). Bonus cap: {cap} CZ$ per season",
    "seasonObjective": "Finish top half of your division: {amount} CZ$ at season end",
    "seasonObjectiveTop40": "Finish top 40% of your division: {amount} CZ$ at season end"
  },
  "field": {
    "guaranteedBase": "Guaranteed at season start",
    "perRaceDay": "Per stage entered",
    "raceDayMath": "{count} stages × {rate} CZ$",
    "ifYouStartEveryStage": "If you start every stage",
    "signingBonus": "Signing bonus",
    "bonusUpside": "Bonuses on top, if earned",
    "length": "Length",
    "seasons": "{count, plural, one {# season} other {# seasons}}"
  },
  "contract": {
    "title": "Current sponsor",
    "loading": "Loading sponsor contract",
    "errorTitle": "Couldn't load your sponsor contract",
    "error": "Nothing was lost and your contract is safe. Try again.",
    "retry": "Try again",
    "none": "No active sponsor contract.",
    "runsThrough": "Runs through season {season}",
    "sponsorName": "Sponsor",
    "clausesTitle": "Bonus clauses",
    "earningsTitle": "Earned on this contract",
    "earningsBase": "Season start",
    "earningsSigning": "Signing bonus",
    "earningsRaceDays": "Stages",
    "earningsResults": "Result bonuses",
    "earningsObjective": "Season objective",
    "earningsTotal": "Total"
  },
  "income": {
    "title": "Sponsor income",
    "meta": "{sponsor} · this season",
    "metaNoSponsor": "This season",
    "loading": "Loading sponsor income",
    "errorTitle": "Couldn't load your sponsor income",
    "error": "Nothing was lost and your balance is safe. Try again.",
    "retry": "Try again",
    "totalLabel": "Total this season",
    "split": "Guaranteed {guaranteed} · earned on top {earned}",
    "group": {
      "fixed": {
        "title": "Fixed income",
        "row": "Season base (contract guarantee)"
      },
      "raceDays": {
        "title": "Stages",
        "row": "{raceName} · {days, plural, one {# stage} other {# stages}} at {rate} CZ$",
        "unknownRace": "Race",
        "showAll": "Show all {count} races",
        "showLess": "Show less"
      },
      "bonuses": {
        "title": "Bonuses",
        "stageWin": "Stage win bonus · {raceName}",
        "podium": "Podium bonus · {raceName}",
        "signing": "Signing bonus",
        "objective": "Season objective bonus",
        "generic": "Result bonus · {raceName}",
        "capLine": "Result bonus cap this season: {used} of {limit} used"
      }
    },
    "footer": {
      "full": "Why you get paid: your contract guarantees a season base, pays per stage your team starts, and adds bonuses for stage wins and podiums.",
      "noBonuses": "Why you get paid: your contract guarantees a season base and pays per stage your team starts."
    },
    "empty": {
      "title": "No sponsor income yet",
      "description": "Income shows up here once your season base is credited and your team starts racing."
    }
  }
}
